export default "__VITE_ASSET__Dk9X9_0H__"